import { render, staticRenderFns } from "./OrderReviewContact.vue?vue&type=template&id=4e272143&scoped=true&"
import script from "./OrderReviewContact.vue?vue&type=script&lang=js&"
export * from "./OrderReviewContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e272143",
  null
  
)

export default component.exports